module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui dividing header"
  }, [_vm._v("\n    Planner\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ui three column centered grid"
  }, [_c('div', {
    staticClass: "center aligned column"
  }, [_c('Clock')], 1), _vm._v(" "), _c('div', {
    staticClass: "center aligned column"
  }, [_c('Timer')], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('Todo')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c98b135c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 28
// module chunks = 0